'use strict';

import handlebars from 'handlebars';

const COMPILED_TEMPLATES = {};

// Register custom Handlebars helpers
handlebars.registerHelper('eq', function (a, b) {
    return a === b;
});

handlebars.registerHelper('neq', function (a, b) {
    return a !== b;
});

function render(templateId, data, withoutCaching)
{
    let template = getCompiledTemplate(templateId, withoutCaching);
    data['html'] = {
        'lt': '<',
        'gt': '>'
    };
    return template(data);
}

function getCompiledTemplate(templateId, withoutCaching)
{
    let compiled = COMPILED_TEMPLATES[templateId];
    if (!compiled || withoutCaching) {
        let template = document.importNode(document.getElementById(templateId).content, true),
            html = template2string(template);
        compiled = handlebars.compile(html);
        COMPILED_TEMPLATES[templateId] = compiled;
    }
    return compiled;
}

function template2string(element)
{
    let div = document.createElement('div');
    div.appendChild(element.cloneNode(true));
    return div.innerHTML;
}

export default { render };
